var _style, _title, _desc, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13 13",
    style: {
      enableBackground: "new 0 0 13 13"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#484848;}\n")), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group Copy")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-830.000000, -453.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(830.000000, 453.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,1.1h-0.5V0.5C10.3,0.2,10,0,9.8,0S9.2,0.2,9.2,0.5v0.5H7V0.5C7,0.2,6.8,0,6.5,0 S6,0.2,6,0.5v0.5H3.8V0.5C3.8,0.2,3.5,0,3.2,0S2.7,0.2,2.7,0.5v0.5H2.2C1,1.1,0,2.1,0,3.2v7.6C0,12,1,13,2.2,13h8.7 c1.2,0,2.2-1,2.2-2.2V3.2C13,2.1,12,1.1,10.8,1.1z M2.2,2.2h0.5v0.5C2.7,3,3,3.2,3.2,3.2S3.8,3,3.8,2.7V2.2H6v0.5 C6,3,6.2,3.2,6.5,3.2S7,3,7,2.7V2.2h2.2v0.5c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V2.2h0.5c0.6,0,1.1,0.5,1.1,1.1v1.1H1.1V3.2 C1.1,2.7,1.6,2.2,2.2,2.2z M10.8,11.9H2.2c-0.6,0-1.1-0.5-1.1-1.1V5.4h10.8v5.4C11.9,11.4,11.4,11.9,10.8,11.9z"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 3.5,
    cy: 7.5,
    r: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5.5,
    cy: 7.5,
    r: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 7.5,
    cy: 7.5,
    r: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 9.5,
    cy: 7.5,
    r: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 3.5,
    cy: 9.5,
    r: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5.5,
    cy: 9.5,
    r: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 7.5,
    cy: 9.5,
    r: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 9.5,
    cy: 9.5,
    r: 0.5
  })));
}

export default SvgCalendar;